"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layer = void 0;
/**
 * A drawing surface used while rendering.
 */
var Layer = /** @class */ (function () {
    function Layer(device, canvasType) {
        this.device = device;
        this.canvas = device.createCanvas(canvasType);
        this.ctx = this.canvas.getContext("2d");
        this._screenSpace = {
            width: this.canvas.width,
            height: this.canvas.height
        };
        this._transform();
    }
    Layer.prototype.getToScreenScale = function () {
        return this._toScreenScale;
    };
    /**
     * Updates the canvas size. If width/height has changed, the canvas will be cleared.
     *
     * @param size The target size.
     */
    Layer.prototype.resizeTo = function (size) {
        this._screenSpace = size;
        var virtualSize = this.device.toVirtualRenderResolution(size);
        var deviceScale = {
            x: this.device.transform.scale.x * this.device.pixelRatio,
            y: this.device.transform.scale.y * this.device.pixelRatio
        };
        var horizontalScale = virtualSize.width / this._screenSpace.width / deviceScale.x;
        var verticalScale = virtualSize.height / this._screenSpace.height / deviceScale.y;
        this._toScreenScale = 1 / Math.min(horizontalScale, verticalScale);
        // Note: any set operation on canvas width/height will implicitly cause the
        // canvas to be cleared, even if the old/new values are the same. The
        // global scale also gets reset.
        if (this.canvas.width !== virtualSize.width
            || this.canvas.height !== virtualSize.height) {
            this.canvas.width = virtualSize.width;
            this.canvas.height = virtualSize.height;
            this._transform();
        }
    };
    /**
     * Sets all pixels back to transparent.
     */
    Layer.prototype.clear = function () {
        // Note: Using the rounded up values of `virtualSize` ensures edge pixels are cleared too.
        var virtualSize = this.device.toVirtualRenderResolution(this._screenSpace);
        this.ctx.save();
        this._undoTransform();
        this.ctx.clearRect(0, 0, virtualSize.width, virtualSize.height);
        this.ctx.restore();
        return this;
    };
    Layer.prototype.drawOn = function (ctx) {
        ctx.drawImage(this.canvas, 0, 0, this._screenSpace.width, this._screenSpace.height);
    };
    Layer.prototype._transform = function () {
        var resolution = this.device.toVirtualRenderResolution(this._screenSpace);
        this.ctx.scale(resolution.width / this._screenSpace.width, resolution.height / this._screenSpace.height);
    };
    Layer.prototype._undoTransform = function () {
        var resolution = this.device.toVirtualRenderResolution(this._screenSpace);
        this.ctx.scale(this._screenSpace.width / resolution.width, this._screenSpace.height / resolution.height);
    };
    return Layer;
}());
exports.Layer = Layer;
//# sourceMappingURL=Layer.js.map